import { Injectable, OnDestroy } from '@angular/core';

import { Observable, Subject, tap } from 'rxjs';

import { IrisModalService, IrisModalSize } from '@sondermind/iris/modal';
import { BreakpointsService } from '@sondermind/utilities/services';

import { colorDecSandElevation1 } from '@sondermind/iris-design-tokens/design-tokens';
import { DirectBookingData, DirectBookingResult } from '../direct-booking/direct-booking-types';
import { DirectBookingComponent } from '../direct-booking/direct-booking.component';

@Injectable()
export class DirectBookingComponentService implements OnDestroy {
  private destroy$ = new Subject<void>();

  constructor(
    private bpService: BreakpointsService,
    private irisModalService: IrisModalService,
  ){ }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  openDialog(data: DirectBookingData): Observable<DirectBookingResult> {
    this.bpService.toggleModal(true);

    const modalRef = this.irisModalService.open<DirectBookingComponent, DirectBookingData, DirectBookingResult>(
      DirectBookingComponent,
      {
        data,
        size: IrisModalSize.LG,
        showHeader: false,
        customStyles: {
          backgroundColor: colorDecSandElevation1,
          padding: '0',
          borderRadius: '2rem',
          width: '100%'
        }
      },
    );

    return modalRef.afterClosed$().pipe(
      tap(() => this.bpService.toggleModal(false)),
    );
  }
}
